import { useEffect, useState } from 'react'
import growthbook from '~/configs/growthBook'
import { useAuth } from '~/modules/auth/redux/hook'
import authApi from '~/modules/auth/services'
import DataLoading from '~/components/common/DataLoading'

const ControlPannelLayout = ({ children }: { children: React.ReactNode }) => {
  const { authState } = useAuth()
  const firebaseUserId = authApi.getUserFirebaseId()
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    growthbook.setAttributes({
      id: authState?.data?.userId,
      email: authState?.data?.userEmail,
      firebaseUserId: firebaseUserId || authState?.data?.userId,
    })
    setIsLoaded(true)
  }, [authState, firebaseUserId])
  return isLoaded ? children : <DataLoading loading />
}

export default ControlPannelLayout
